import http from '@/http'
import { groupBy } from 'lodash'
import createCrudModule from 'vuex-crud'

let parseError = res => res
let parseSingle = res => res

export default createCrudModule({
  client: http,
  resource: 'complexes',
  urlRoot: 'complexes',

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data
    })
  },

  state: {
    projectsList: []
  },

  mutations: {
    setProjectsList(state, projectsList) {
      state.projectsList = projectsList
    }
  },

  actions: {
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`complexes/${id}`, data, config)
        .then(res => {
          let parsedResponse = parseSingle(res)
          commit('updateSuccess', parsedResponse)
          return parsedResponse
        })
        .catch(err => {
          let parsedError = parseError(err)
          commit('updateError', parsedError)
          return Promise.reject(parsedError)
        })
    },

    getProjectsList({ commit }) {
      return http.get(`data/1c/projects`).then(res => {
        let parsedResponse = parseSingle(res)
        commit('setProjectsList', parsedResponse.data)
        return parsedResponse
      })
    }
  },

  getters: {
    groupBy: state => name => {
      return groupBy(state.entities, name)
    }
  }
})
